export enum CPDialogResult {
  close = 0,
  ok = 1,
  cancel = 2
}
